import { KeyValue } from "../models/KeyValue";

export const TIME_REPORT_STATUS_KEY_VALUES: KeyValue[] = [
	{ key: "FUTURE_TIME_REPORT", value: "FUTURE_TIME_REPORT" },
	{ key: "PENDING", value: "PENDING_REPORT" },
	{ key: "WORKED", value: "WORKED" },
	{ key: "ATTESTED_BY_ADMIN", value: "ATTESTED_INTERNALLY" },
	{ key: "ATTESTED_BY_CUSTOMER", value: "CUSTOMER_ATTEST" },
	{ key: "SILENT_ATTESTED", value: "SILENT_ATTESTED" },
	{ key: "DECLINED_BY_CUSTOMER", value: "DECLINED" },
	{ key: "INVOICED", value: "INVOICED" },
	{ key: "SICK_LEAVE", value: "SICK_LEAVE" },
	{ key: "CHILD_CARE", value: "CHILD_CARE" },
];
